// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__x08jj","error":"Login_error__7pOy6","registerButton":"Login_registerButton__r_aPR","resetPassword":"Login_resetPassword__CbNj9"};